import axios from "axios";

const instance = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    withCredentials: true,
    credentials: "include",
    headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
    },
    transformResponse: [
        (data) => {
            let resp
        
            try {
                if(data.length)
                {
                    resp = JSON.parse(data, function (key, value) {
                        if (key == 'date') {
                            return new Date(value);
                        }
                        return value;
                    });
                }
            } catch (error) {
                throw Error(`[requestClient] Error parsing response JSON data - ${JSON.stringify(error)}`)
            }

            if (resp) {
                return resp
            }
            
            throw Error(`[requestClient] Request failed with reason - ${data}`)
        }
    ]
});

export default instance;
